/** api/history.js — Histórico de execuções (Bloco 6). GET /history */
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client';

export function useHistory() {
  const api = useApi();
  return useQuery({ queryKey: ['history'], queryFn: () => api.get('/history') });
}
